module.exports = __webpack_public_path__ + "static/media/XQ2.6e9d1e5f.png";